import { Injectable } from '@angular/core';
@Injectable()
export class StoryContact {
    address: string;
    emailAddress: string;
    mobileNumber: any;
    name: string;
    phoneNumber: any;
    title: string;
    webAddress: string;
    ranking?: number;
    imageData?: string;
    id: number;
}

